import React from 'react';

import { shouldRenderMobile } from '@philips-emr/hpms-health-insurance-components';
import { AvatarAPI, Copyright, ImageAPI, Link, SocialNetworksAPI } from '@philips-emr/tws-components';
import { DismissStyle, ThemeTonalRange, ToastLevel } from '@philips-emr/tws-constants';
import Controller, { OnClick, OnMount } from '@philips-emr/tws-core/lib/client';
import { MountEvent } from '@philips-emr/tws-core/lib/component/types';
import { MessageService, ModalService, ToastService } from '@philips-emr/tws-core/lib/services';

import { FooterNoLoginAliases as Aliases, FragmentNames } from '../codegen';
import { Configuration, Wsuite } from '../services/configuration';

import './health-declaration/health-declaration.scss';

@Controller({ fragment: FragmentNames.FOOTER_NO_LOGIN })
export default class FooterNoLoginController {

  @OnMount(Aliases.SOCIAL_NETWORKS)
  onSocialNetworksMount(event: MountEvent): void {
    const api = event.target as SocialNetworksAPI;

    void Configuration.getData().then((data: Wsuite) => {
      data.dsLinkFacebook && api.setFacebook(data.dsLinkFacebook);
      data.dsLinkInstagram && api.setInstagram(data.dsLinkInstagram);
      data.dsLinkLinkedin && api.setLinkedin(data.dsLinkLinkedin);
      data.dsLinkTwitter && api.setTwitter(data.dsLinkTwitter);
      data.dsLinkYoutube && api.setYoutube(data.dsLinkYoutube);
    });
  }

  @OnMount(Aliases.IMAGE_FOOTER)
  onImageFooterMount(event: MountEvent): void {
    const api = event.target as ImageAPI;

    void Configuration.getData().then((data: Wsuite) => {
      data.dsUrlLogoFooter && api.setSrc(data.dsUrlLogoFooter);
    });
  }

  @OnMount(Aliases.AVATAR_ADDRESS)
  onAvatarAddressMount(event: MountEvent): void {
    const api = event.target as AvatarAPI;
    void Configuration.getData().then((data: Wsuite) => data.dsAddress && api.setTitle(data.dsAddress));
  }

  @OnMount(Aliases.AVATAR_CONTACT)
  onAvatarContactMount(event: MountEvent): void {
    const api = event.target as AvatarAPI;
    void Configuration.getData().then((data: Wsuite) => {
      const { nrContactPhone = '', dsEmailFooter = '' } = data;

      if (shouldRenderMobile()) {
        api.setTitle(`${MessageService.translate('hi.telephone')}: ${nrContactPhone}`);
        api.setSubtitle(`${MessageService.translate('hi.email')}: ${dsEmailFooter}`);
      } else {
        api.setTitle(`${MessageService.translate('hi.telephone')}: ${nrContactPhone} | ${MessageService.translate('hi.email')}: ${dsEmailFooter}`);
      }
    });
  }

  @OnMount(Aliases.LINK_COOKIES)
  onLinkCookiesMount(): void {
    ToastService.open({
      id: 'c-toast-notification__message--cookies',
      title: 'hi.cookies-policy',
      message: 'hi.cookie',
      dismissible: true,
      dismissStyle: DismissStyle.BUTTON,
      showIcon: true,
      dismissExpression: 'OK',

      action: (<Link onClick={() =>
        ModalService.openDefault({
          theme: ThemeTonalRange.ULTRA_LIGHT,
          closeable: true,
          fragment: 'cookie',
          title: 'hi.cookies-policy',
        })
      } value={'hi.cookies-policy'} />),

      level: ToastLevel.WARNING,
      highlight: true,
    });
  }

  @OnClick(Aliases.LINK_COOKIES)
  onLinkCookiesClick(): void {
    ModalService.openDefault({
      theme: ThemeTonalRange.ULTRA_LIGHT,
      closeable: true,
      children: (<Copyright applicationName={'hi.title'} />),
    });
  }

  @OnClick(Aliases.LINK_VERSION)
  onLinkVersionClick(): void {
    ModalService.openDefault({
      theme: ThemeTonalRange.ULTRA_LIGHT,
      closeable: true,
      children: (<Copyright applicationName={'hi.title'} />),
    });
  }

}
